import { jsx, jsxs } from 'react/jsx-runtime';
import { Typography } from '@design-system/typography';
import { Events } from '@phx-husky/auth-service';
import ConfirmCode from '@phx-husky/confirm-code';
import { triggerCustomEvent } from '@phx-husky/custom-event';
import { InformationModal } from '@phx-husky/information-modal';
import { useConfig } from '@phx-husky/use-config';
import { useProfile } from '@phx-husky/use-profile';
import { useSignUp } from '@phx-husky/use-sign-up';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import { useState } from 'react';

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".account-confirmation-module_accountConfirmation__xbBu0 {\n  font-family: var(--phx-fontFamily, Lato, sans-serif);\n  padding: var(--phx-accountConfirmationModalPadding, var(--cds-space-6) var(--cds-space-3));\n  margin: 0 auto;\n}\n\n@media screen and (min-width: 576px) {\n  .account-confirmation-module_accountConfirmation__xbBu0 {\n    max-width: var(--phx-accountConfirmationModalMaxWidth, 360px);\n  }\n}\n\n.account-confirmation-module_logo__HjrkC {\n  margin-bottom: var(--cds-space-3);\n}\n\n.account-confirmation-module_title__RGYWF {\n  color: var(--phx-textColor, #101010);\n}\n\n.account-confirmation-module_description__1JhbA {\n  margin: var(--cds-space-5) 0 var(--cds-space-7) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFjY291bnQtY29uZmlybWF0aW9uLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usb0RBQW9EO0VBQ3BELDBGQUEwRjtFQUMxRixjQUFjO0FBQ2hCOztBQUNBO0VBQ0U7SUFDRSw2REFBNkQ7RUFDL0Q7QUFDRjs7QUFFQTtFQUNFLGlDQUFpQztBQUNuQzs7QUFFQTtFQUNFLG9DQUFvQztBQUN0Qzs7QUFFQTtFQUNFLGlEQUFpRDtFQUNqRCw2Q0FBNkM7QUFDL0MiLCJmaWxlIjoiYWNjb3VudC1jb25maXJtYXRpb24ubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYWNjb3VudENvbmZpcm1hdGlvbiB7XG4gIGZvbnQtZmFtaWx5OiB2YXIoLS1waHgtZm9udEZhbWlseSwgTGF0bywgc2Fucy1zZXJpZik7XG4gIHBhZGRpbmc6IHZhcigtLXBoeC1hY2NvdW50Q29uZmlybWF0aW9uTW9kYWxQYWRkaW5nLCB2YXIoLS1jZHMtc3BhY2UtNikgdmFyKC0tY2RzLXNwYWNlLTMpKTtcbiAgbWFyZ2luOiAwIGF1dG87XG59XG5AbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA1NzZweCkge1xuICAuYWNjb3VudENvbmZpcm1hdGlvbiB7XG4gICAgbWF4LXdpZHRoOiB2YXIoLS1waHgtYWNjb3VudENvbmZpcm1hdGlvbk1vZGFsTWF4V2lkdGgsIDM2MHB4KTtcbiAgfVxufVxuXG4ubG9nbyB7XG4gIG1hcmdpbi1ib3R0b206IHZhcigtLWNkcy1zcGFjZS0zKTtcbn1cblxuLnRpdGxlIHtcbiAgY29sb3I6IHZhcigtLXBoeC10ZXh0Q29sb3IsICMxMDEwMTApO1xufVxuXG4uZGVzY3JpcHRpb24ge1xuICBtYXJnaW46IHZhcigtLWNkcy1zcGFjZS01KSAwIHZhcigtLWNkcy1zcGFjZS03KSAwO1xuICBjb2xvcjogdmFyKC0tcGh4LXNlY29uZGFyeVRleHRDb2xvciwgIzRhNGE0YSk7XG59Il19 */";
var styles = {"accountConfirmation":"account-confirmation-module_accountConfirmation__xbBu0","logo":"account-confirmation-module_logo__HjrkC","title":"account-confirmation-module_title__RGYWF","description":"account-confirmation-module_description__1JhbA"};
styleInject(css_248z);

var ConfirmationMode;
(function (ConfirmationMode) {
    ConfirmationMode["AccountConfirmation"] = "AccountConfirmation";
    ConfirmationMode["FieldConfirmation"] = "FieldConfirmation";
})(ConfirmationMode || (ConfirmationMode = {}));

const AccountConfirmation = ({ attributeValue, email, title, description, codeDeliveryMedium, mode, attributeName, onConfirmationCallback, }) => {
    const { confirmSignUp, resendSignUpCode } = useSignUp();
    const { verifyCurrentUserAttributeSubmit } = useProfile();
    const { renderLogo } = useConfig();
    const [errorMessage, setErrorMessage] = useState('');
    const { translate } = useTranslations();
    const [pending, setPending] = useState(false);
    const [congratulationInfo, setCongratulationInfo] = useState(false);
    const confirmationCallback = () => {
        if (onConfirmationCallback) {
            onConfirmationCallback();
            return;
        }
        if (mode === ConfirmationMode.AccountConfirmation) {
            triggerCustomEvent(Events.onAccountConfirmation, { visible: false });
        }
        else {
            triggerCustomEvent(Events.onUserAttributesSubmitWithCode, {
                visible: false,
            });
        }
    };
    const resendCode = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setPending(true);
        try {
            yield resendSignUpCode({ username: email });
            setPending(false);
        }
        catch (error) {
            setPending(false);
            setErrorMessage(error);
        }
    });
    const submit = (e, verificationCode) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!verificationCode) {
            setErrorMessage(translate('confirmationCodeRequiredErrorMessage'));
            return;
        }
        let result;
        if (mode === ConfirmationMode.FieldConfirmation && attributeName) {
            result = yield verifyCurrentUserAttributeSubmit({
                attributeName,
                verificationCode,
            });
        }
        else {
            result = yield confirmSignUp({
                username: email,
                verificationCode,
            });
        }
        if (result === null || result === void 0 ? void 0 : result.success) {
            setCongratulationInfo(true);
        }
        else {
            setErrorMessage((result === null || result === void 0 ? void 0 : result.message) || '');
        }
    });
    const payload = {
        translationPrefix: 'accountConfirmation',
    };
    return congratulationInfo ? (jsx(InformationModal, { message: ConfirmationMode.AccountConfirmation
            ? translate('accountConfirmationCongratulationText')
            : translate('phoneNumberChangeSubmitCongratulationText'), title: translate('accountConfirmationCongratulationTitle'), callback: confirmationCallback })) : (jsxs("div", Object.assign({ className: classNames(styles.accountConfirmation, 'account-confirmation'), id: "account-confirmation" }, { children: [renderLogo ? renderLogo({ className: styles.logo }) : null, jsx(Typography, { tag: "h2", variant: "headline", size: "m", weight: "bold", className: styles.title, "data-translate-key": "accountConfirmationTitle", content: title || translate('accountConfirmationTitle') }), jsx(Typography, { tag: "p", variant: "body", size: "m", className: styles.description, "data-translate-key": `accountConfirmationCheckInfo${codeDeliveryMedium}`, content: description ||
                    `${translate(`accountConfirmationCheckInfo${codeDeliveryMedium}`)}  <strong>${attributeValue}</strong>` }), jsx(ConfirmCode, { additionalData: payload, submit: submit, attributeValue: attributeValue, errorMessage: errorMessage, resendCode: mode === ConfirmationMode.AccountConfirmation && resendCode, pending: pending, mode: mode })] })));
};

export { ConfirmationMode, AccountConfirmation as default };
